import { Observable } from 'rxjs';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Injectable } from '@angular/core';

import { AppComfirmComponent } from './app-confirm.component';
import { AppComfirm2Component } from './app-confirm2.component';

interface confirmData {
  title?: string,
  message?: string
}

@Injectable()
export class AppConfirmService {

  constructor(private dialog: MatDialog) { }

  public confirm(data:confirmData = {}): Observable<boolean> {
    data.title = data.title || 'Undefined';
    data.message = data.message || 'Undefined';
    let dialogRef: MatDialogRef<AppComfirmComponent>;
    dialogRef = this.dialog.open(AppComfirmComponent, {
      width: '380px',
      data: {title: data.title, message: data.message}
    });
    return dialogRef.afterClosed();
  }

  public confirm2(data:confirmData = {}): Observable<boolean> {
    data.title = data.title || 'Undefined';
    data.message = data.message || 'Undefined';
    let dialogRef: MatDialogRef<AppComfirm2Component>;
    dialogRef = this.dialog.open(AppComfirm2Component, {
      width: '380px',
      data: {title: data.title, message: data.message}
    });
    return dialogRef.afterClosed();
  }
}